import { render } from "./AdminPanel.vue?vue&type=template&id=edc30674&scoped=true"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"

import "./AdminPanel.vue?vue&type=style&index=0&id=edc30674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc30674"]])

export default __exports__